import { render, staticRenderFns } from "./WorkspaceArea.vue?vue&type=template&id=3254fedf&"
import script from "./WorkspaceArea.vue?vue&type=script&lang=js&"
export * from "./WorkspaceArea.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports